var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background",class:( _obj = {
    'align-left': _vm.alignment == 'Left' || !_vm.alignment,
    'align-right': _vm.alignment == 'Right',
    'align-centre': _vm.alignment == 'Centre'
  }, _obj[_vm.theme.toLowerCase()] = true, _obj ),style:({ backgroundImage: _vm.backgroundUrl ? ("url(" + _vm.backgroundUrl + ")") : '' })},[_c('container',[_c('div',[_c('prismic-text',{attrs:{"blocks":_vm.copy}}),(_vm.buttonLink)?_c('prismic-link',{attrs:{"link":_vm.buttonLink}},[_c('app-button',{class:{ secondary: _vm.backgroundColour == 'dark' }},[_vm._v(_vm._s(_vm.buttonText))])],1):_vm._e()],1),(_vm.imageUrl)?_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.imageUrl}})]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }